import { Component, inject, OnInit, signal } from '@angular/core';
import { PartsService } from '../core/parts.service';
import { FiltersComponent } from '../home/filters.component';
import { Part } from '../core/models/part';
import { PartTabsComponent } from '../parts/part-tabs.component';
import { PartTypeGridComponent } from '../parts/part-type-grid.component';

@Component({
    selector: 'app-home-shared',
    imports: [FiltersComponent, PartTabsComponent, PartTypeGridComponent],
    template: `
        @if (!loading()) {
        <div class="nadiesel-shop">
            <div class="master-wrapper-content">
                <div class="center-1">
                    <app-filters />
                    <div class="page home-page">
                        <div class="page-body">
                            <app-part-type-grid />
                            <app-part-tabs [parts]="featuredParts()" [pageSize]="8" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
    `,
    styles: ``
})
export class HomeSharedComponent implements OnInit {
    partsService = inject(PartsService);
    loading = signal(false);
    featuredParts = signal<Part[]>([]);

    async ngOnInit() {
        this.loading.set(true);

        await Promise.all([
            this.partsService.getPartTypes(),
            this.partsService.getMakes(),
            this.partsService.getPartTypeModelMaps()
        ]);

        let featuredParts = await this.partsService.getParts({ hasPictures: true, isFeatured: true, hasPrice: true, take: 8 });
        this.featuredParts.set(featuredParts);

        this.loading.set(false);
    }
}
